/**
 * DreResumoWidget — DRE resumido do mes corrente.
 */
import React from "react";
import { Link } from "react-router-dom";

import { obterDre } from "../../../services/financeiro";

import { CardBody, KpiValor, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "dre_resumo",
  label: "DRE resumido",
  descricao: "Receita - TVC - OE = Lucro liquido (regime competencia).",
  categoria: "Financeiro",
  permissoes: ["financeiro:view"],
  tamanho_default: "M",
  essencial: false,
};

export async function fetchData(request) {
  // Janela: mes corrente (sem params explicitos, backend usa default)
  return await obterDre(request);
}

function fmt(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return "—";
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 });
}

export function Widget({ dados }) {
  const r = dados?.receita ?? null;
  const tvc = dados?.tvc ?? null;
  const oe = dados?.oe ?? dados?.despesa_fixa ?? null;
  const lucro = dados?.lucro_liquido ?? null;
  return (
    <>
      <CardBody>
        <KpiValor>{fmt(lucro)}</KpiValor>
        <KpiSub>Lucro liquido (periodo)</KpiSub>
        <div style={{ marginTop: 6, fontSize: "0.82rem", display: "flex", flexDirection: "column", gap: 2 }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>Receita</span><strong>{fmt(r)}</strong>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>− TVC</span><strong>{fmt(tvc)}</strong>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>− OE</span><strong>{fmt(oe)}</strong>
          </div>
        </div>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/financeiro/dre">Ver DRE</LinkLight>
      </CardFooter>
    </>
  );
}
